// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import {
  GET_ALL_CARD_REPORTS,
  GET_ALL_CARD_REPORTS_SUCCESS,
  GET_ALL_CARD_REPORTS_ERROR,
} from "../../constants";
import axios from "../../../../services/api";

function* getAllReports(data) {
  try {
    const params = new URLSearchParams();

    params.append("report", 1);

    if (data.startdate) {
      params.append("startdate", data.startdate);
    }
    if (data.enddate) {
      params.append("enddate", data.enddate);
    }
    if (data.companyIds) {
      params.append("companyIds", data.companyIds);
    }
    if (data.contractorIds) {
      params.append("contractorIds", data.contractorIds);
    }
    if (data.issuerIds) {
      params.append("issuerIds", data.issuerIds);
    }
    if (data.statusType) {
      params.append("type", data.statusType);
    }
    if (data.sort) {
      params.append("sort", data.sort);
    }
    if (data.search) {
      params.append("search", data.search);
    }

    const response = yield call(axios.get, "/reports-card/", { params });
    if (response.data.error) {
      yield put({
        type: GET_ALL_CARD_REPORTS_ERROR,
        data: response.error,
      });
    } else {
      yield put({
        type: GET_ALL_CARD_REPORTS_SUCCESS,
        data: response.data,
      });

      data.callBack(response.data);
    }
  } catch (error) {
    yield put({
      type: GET_ALL_CARD_REPORTS_ERROR,
      data: error,
    });
  }
}

export default function* getAllReportsSaga() {
  yield takeLatest(GET_ALL_CARD_REPORTS, getAllReports);
}
